import { SvgIcon, SvgIconProps } from '@mui/material';
import { memo } from 'react';
const SvgEnlarge32 = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <path d="m29.438 28.594-7.688-7.688q1.438-1.531 2.266-3.531t.828-4.25q0-2.313-.875-4.375t-2.406-3.594q-1.531-1.563-3.594-2.453t-4.438-.891q-2.313 0-4.344.891T5.624 5.156Q4.093 6.687 3.218 8.75t-.875 4.375.891 4.375 2.391 3.594q1.531 1.531 3.594 2.438t4.438.906q1.906 0 3.625-.609t3.094-1.641l7.781 7.781q.156.156.313.234t.344.078q.156 0 .313-.078t.313-.234q.25-.313.25-.734t-.25-.641zM4.156 13.125q0-1.969.75-3.688t2.031-3Q8.25 5.124 9.968 4.374t3.688-.75 3.688.75 3 2.063q1.313 1.281 2.063 3t.75 3.688-.75 3.688-2.063 3.031q-1.281 1.281-3 2.031t-3.688.75-3.688-.75-3.031-2.031q-1.281-1.313-2.031-3.031t-.75-3.688m9.375 5.969q-.375 0-.656-.281t-.281-.688V8q0-.406.281-.688t.656-.281q.406 0 .688.281T14.5 8v10.125q0 .406-.281.688t-.688.281m5.125-5H8.531q-.406 0-.688-.281t-.281-.688.281-.688.688-.281h10.125q.406 0 .688.281t.281.688-.281.688-.688.281" />
    </SvgIcon>
  );
};
const Memo = memo(SvgEnlarge32);
export default Memo;
